/* =============================================================================
 * MEDICION · que se mide, con que identificador, y por que esta aqui a la vista.
 * -----------------------------------------------------------------------------
 * EL ID DEL PIXEL NO ES UN SECRETO Y NO DEBE TRATARSE COMO TAL. Viaja dentro del
 * HTML de cada visitante y sale en la barra de direcciones de cualquier peticion
 * a `facebook.com/tr`: esconderlo en una variable de entorno daria una sensacion
 * de seguridad falsa y ademas obligaria a pasar argumentos de build al contenedor
 * para algo que el navegador publica igualmente. Vive aqui, tipado y con su
 * fecha, como cualquier otro dato de negocio del repo.
 *
 * LO QUE SI ES SECRETO es el token de la Conversions API, y **no esta en este
 * repo ni puede estarlo**: vive en Vault (`secret/amai/azrahel-meta`) y solo lo
 * usa el servidor de la tienda (pretix). Una web estatica no puede guardar un
 * secreto — cualquier cosa que le pongas la lee el visitante.
 *
 * PAREJA CON LA TIENDA: este mismo pixel esta configurado en
 * `entradas.eventoazrahel.com`. Es a proposito: si la landing midiera con un
 * pixel y la tienda con otro, Meta veria dos publicos sin relacion y el embudo
 * (visita -> compra) no se podria cerrar nunca.
 * ========================================================================== */

/**
 * Pixel de Meta de Azrahel del Mayor para su campana del 2-nov-2026, indicado por Luis.
 * La tienda y el Club siguen con el anterior (1722124942396079): hasta igualarlos,
 * el embudo web -> compra no se cierra en Meta (ver PAREJA CON LA TIENDA).
 */
export const META_PIXEL_ID = '1722124942398079';

/**
 * Clave del consentimiento en `localStorage`.
 *
 * Lleva version en el nombre a proposito: el dia que se anada un proveedor nuevo
 * (GA4, Ads...) el consentimiento anterior **ya no cubre lo que se pregunto**, y
 * subir la version vuelve a preguntar en vez de dar por buena una respuesta que
 * el visitante dio sobre otra cosa. Reutilizar la clave seria asumir un permiso
 * que nadie dio.
 */
export const CONSENT_STORAGE_KEY = 'az-consent-v1';

/** Cuanto vale un «si» antes de volver a preguntar. La AEPD recomienda 24 meses. */
export const CONSENT_MAX_AGE_DAYS = 180;
